import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";

import dayjs from "dayjs";
import { getPracticeId } from "../../config/practice";

const AbdominalUltrasoundview = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/${getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );
    
      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);

  return (
    <div
      className="p-6 bg-white min-h-screen w-full flex justify-center items-center"
      id={examData ? "report-ready" : undefined}
    >
      <div className="w-full max-w-3xl flex flex-col items-center border border-gray-300 rounded-md p-12 shadow-sm">
        {/* Header */}
        <div className="flex items-start w-full justify-center">
          <img src={BrianyCareLogo} alt="Logo" className="w-14 h-14 mr-3" />
          <div>
            <h1 className="text-xl font-bold text-blue-600 leading-none text-start">C-HIM</h1>
            <p className="text-sm font-semibold mt-1">Center for Hypertension & Internal Medicine</p>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center font-bold text-base underline mb-4">
          ABDOMINAL ULTRASOUND
        </h2>

        {/* Patient Info */}
        {examData ? (
          <>    <div className="flex justify-start text-sm text-left w-full mb-4">
            <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
              <span><strong>MR No#</strong></span>
              <span>:</span>
              <span>{examData.patient_id}</span>
          
              <span><strong>Name</strong></span>
              <span>:</span>
              <span>{examData.pat_name}</span>
          
              <span><strong>Age</strong></span>
              <span>:</span>
              <span>{examData.pat_age}</span>
          
              <span><strong>Exam Date</strong></span>
              <span>:</span>
              <span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
          
              <span><strong>Date of Birth</strong></span>
              <span>:</span>
              <span>{dayjs(examData.pat_dob).format("MMM D, YYYY")}</span>
          
              <span><strong>Provider</strong></span>
              <span>:</span>
              <span>{examData.providername}</span>
          
              
          
              <span><strong>Patients History</strong></span>
              <span>:</span>
              <span>{examData.pathistory}</span>
            </div>
          </div>
         

            {/* Organs Data */}
   <div className="w-full text-start mb-6 text-sm">
  <div className="grid grid-cols-4 gap-x-6 gap-y-2">
    <div><strong>Aorta:</strong> {examData.aorta.value} {examData.aorta.unit}</div>
    <div><strong>IVC:</strong> {examData.ivc.value} {examData.ivc.unit}</div>
    <div><strong>Liver:</strong> {examData.liver.value} {examData.liver.unit}</div>
    <div><strong>CBD:</strong> {examData.cbd.value} {examData.cbd.unit}</div>

   {examData.gallbladderRemoved ? (
  <div className="col-span-1 sm:col-span-1">
    <strong>Gallbladder:</strong> Removed
  </div>
) : (
  <div>
    <strong>Gallbladder:</strong> {examData.gallbladder.value} {examData.gallbladder.unit}
    {examData.gallbladder.comment && (
      <div className="mt-1 text-sm">
        <strong>Comment:</strong> {examData.gallbladder.comment}
      </div>
    )}
  </div>
)}


    <div><strong>Pancreas:</strong> {examData.pancreas.value} {examData.pancreas.unit}</div>
    <div><strong>Spleen:</strong> {examData.spleen.value} {examData.spleen.unit}</div>
  </div>
</div>




            {/* Kidney Measurements */}
            <div className="w-full text-start mb-6 text-sm">
           
              <div className="grid grid-cols-4 gap-x-6 gap-y-2">
                <div><strong>Rt Kidney L:</strong> {examData.rtKidney.L}</div>
                <div><strong>Rt Kidney W:</strong> {examData.rtKidney.W}</div>
                <div><strong>Rt Kidney H:</strong> {examData.rtKidney.H}</div>
                <div><strong>Unit:</strong> {examData.rtKidney.unit}</div>

                <div><strong>Lt Kidney L:</strong> {examData.ltKidney.L}</div>
                <div><strong>Lt Kidney W:</strong> {examData.ltKidney.W}</div>
                <div><strong>Lt Kidney H:</strong> {examData.ltKidney.H}</div>
                <div><strong>Unit:</strong> {examData.ltKidney.unit}</div>
              </div>
            </div>

            {/* Impression */}
            <div className="text-sm text-start w-full mb-6 ">
              <strong>Sonographers Impression:</strong> {examData.impression}
            </div>

            {/* Signature */}
        <div className="flex justify-end w-full">
  <div className="relative flex items-stretch border p-2 min-w-[350px] max-w-full">
    
    {/* Signature - grows with content */}
    <div className="font-semibold pr-4 z-10 break-words whitespace-pre-wrap max-w-[50%]">
      {examData.signature}
    </div>

    {/* Divider */}
    <div className="absolute top-0 bottom-0 left-1/2 w-px bg-gray-300" />

    {/* Right section - always left aligned */}
    <div className="text-sm text-left z-10 pl-4 w-1/2">
      <div>Digitally Signed by</div>
     <div>{examData?.createdby||''}</div>
         <div>{dayjs(examData.dateofservice).format("MM-DD-YYYY")}</div>
    </div>
  </div>
</div>
          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default AbdominalUltrasoundview;
